module.exports = __WEBPACK_EXTERNAL_MODULE_5__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Survey","commonjs2":"survey-core","commonjs":"survey-core","amd":"survey-core"}
// module id = 5
// module chunks = 0